import { render, staticRenderFns } from "./GrayText.vue?vue&type=template&id=52fb5ea6&"
import script from "./GrayText.vue?vue&type=script&lang=js&"
export * from "./GrayText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports